import "./Home.css"
import SlideShow1 from "./SlideShow";
import { SlideShow2 } from "./SlideShow";
export const Home = () => {
  return (

    <div className="home">
        <div className="gap"></div>
        <div className="offer_add"><h2>WELCOME TO BLUEFLY : Luxury brands at discounted prices</h2></div>
      <div className="slideshow">
        <SlideShow1/>
      </div>
      <br />
      {/* ....................................................................................... */}
      {/* shope category */}

        <p className="p-tag">SHOP BY CATEGORY</p>
        <div className="shop1">
          <div className="shop-11">
            <div className="shop-111">
              <img className="shop-img"
                src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/2227080_large.jpg?v=1649703475"
                alt=""
              />
              <p>DRESSESA</p>
            </div>
          </div>

          <div className="shop-11">
            <div className="shop-111">
              <img
                className="shop-img"
                src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1161192845_RLLZ_2_large.jpg?v=1651592680"
                alt=""
              />
              <p>HANDBAGS</p>
            </div>
        </div>

        <div className="shop-11">
            <div className="shop-111">
              <img
                className="shop-img"
                src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1313201861_RLLZ_2_large.jpg?v=1651370370"
                alt=""
              />
              <p>PUMPS & HEELS</p>
            </div>
        </div>

          <div className="shop-11">
            <div className="shop-111">
              <img
                className="shop-img"
                src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1313202046_RLLZ_1_1800x1800.jpg?v=1651598055"
                alt=""
              />
              <p>WOMEN'S SNEAKERS</p>
            </div>
        </div>

        <div className="shop-11">
            <div className="shop-111">
              <img
                className="shop-img"
                src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/9301c991-9112-4446-91c1-8b9146a43b81_large.jpg?v=1620800351"
                alt=""
              />
              <p>SUNGLASSES</p>
            </div>
        </div>

        </div>
        <div className="shop2">
          <div className="shop-11">
            <div className="shop-111">
              <img
                className="shop-img"
                src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1312134872_RLLZ_2_large.jpg?v=1651561994"
                alt=""
              />
              <p>MEN'S SNEAKERS</p>
            </div>
        </div>

          <div className="shop-11">
            <div className="shop-111">
              <img
                className="shop-img"
                src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1897814_large.jpg?v=1644499725"
                alt=""
              />
              <p>MEN'S T-SHIRTS</p>
            </div>
          </div>
          <div className="shop-11">
            <div className="shop-111">
              <img
                className="shop-img"
                src="https://rukminim1.flixcart.com/image/300/300/kh5607k0-0/top/p/d/6/s-t-344-tani-white-s-dream-beauty-fashion-original-imafx83z4kq7fn2h.jpeg?q=90"
                alt=""
              />
              <p>WOMEN'S TOPS</p>
            </div>
          </div>
          <div className="shop-11">
            <div className="shop-111">
              <img
                className="shop-img"
                src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1540260_large.jpg?v=1636501335"
                alt=""
              />
              <p>WOMEN'S DENIM</p>
            </div>
          </div>
          <div className="shop-11">
            <div className="shop-111">
              <img
                className="shop-img"
                src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/4ctrosebracelet_6a7cee7c-1a9b-4bc9-9a48-16c26d9c9ee7_large.jpg?v=1634340454"
                alt=""
              />
              <p>JEWELRY</p>
            </div>
          </div>
      </div>
      <br />
      <br />
{/* ............................................................................................. */}
        <div className="slideshow">
        <SlideShow2/>
      </div>
{/* ...................................................................................... */}
        <hr />
        <p className="p-tag">NEW ARRIVALS</p>
        <button className="btn">VIEW ALL</button>
        <div className="diva">
          <div className="diva-1">
            <img src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1566289_1800x1800.png?v=1635615949" />
            {/* <button className="hover-btn">Quick view</button> */}
            <p>"DIVA!" T-SHIRT</p>
            <p>
              $420.60 <span className="color">Save 39%</span>{" "}
            </p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/2246722_1080x.jpg?v=1649684335"
              alt=""
            />
            <p>"LA MEDUSA" RUBBER MULES</p>
            <p>
              $385.29 <span className="color">Save 22%</span>{" "}
            </p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/2269028_1080x.jpg?v=1651089252"
              alt=""
            />
            <p>"THE FLUORO MOTO SHOT" BAG</p>
            <p>
              $383.97 <span className="color">Save 22%</span>{" "}
            </p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/2087946_1800x1800.jpg?v=1638291787"
              alt=""
            />
            <p>'FOR RIDING' RAINBOOTS</p>
            <p>$347.65 Save 27%</p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/2149730_76cf6aa7-502b-4b5b-bd8e-31e1af9ed2bb_1800x1800.jpg?v=1646588764"
              alt=""
            />
            <p>'KIKI' STRAW CANOTIER HAT</p>
            <p>$505.65 Save 24%</p>
          </div>
        </div>
        <hr />
        <p className="p-tag">TRENDING NOW</p>
        <div className="diva">
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1311930311_RLLZ_1_1800x1800.jpg?v=1651699524"
              alt=""
            />
            <p>STUART WEITZMAN LOWLAND SUEDE OVER-THE-KNEE BOOT</p>
            <p>
              $264.99 <span className="color">Save 76%</span>{" "}
            </p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/wtlliMyyv3hcuS7RGVS0VZojPouPYfsw-25_1800x1800.jpg?v=1607399172"
              alt=""
            />
            <p>ROXY WOMENS DOWN WINTER PUFFER COAT</p>
            <p>
              $248.98 <span className="color"> Save 50%</span>
            </p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/9301c991-9112-4446-91c1-8b9146a43b81_large.jpg?v=1620800351"
              alt=""
            />
            <p>DIOR PILOT SUNGLASSES MONSIEUR 1 XWY1I GOLD/BLACK/HAVANA 63MM</p>
            <p>$495.00</p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1885891_1800x1800.jpg?v=1637852340"
              alt=""
            />
            <p>JACQUEMUS BROWN 'LE BAMBINO' LEATHER CROSSBODY PURSE</p>
            <p>$585.00</p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1010994296_RLLZ_1_360x.jpg?v=1651836155"
              alt=""
            />
            <p>GUCCI DOUBLE G LEATHER BELT</p>
            <p>
              $449.99 <span className="color">Save 6%</span>{" "}
            </p>
          </div>
        </div>
        <div className="diva">
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1311784215_RLLZ_1_1800x1800.jpg?v=1651602649"
              alt=""
            />
            <p>STUART WEITZMAN LAINE SUEDE COMBAT BOOT</p>
            <p>
              $279.99 <span className="color">Save 66%</span>{" "}
            </p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/8d21d1b4-11d7-4354-9fde-fd28589989ea_1800x1800.jpg?v=1628207566"
              alt=""
            />
            <p>OFF WHITE C/O VIRGIL ABLOH WHITE ARROWS CARRY ON SUITCASE</p>
            <p>$650.25 Save 36%</p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/9301c991-9112-4446-91c1-8b9146a43b81_large.jpg?v=1620800351"
              alt=""
            />
            <p>GUCCI SQUARE SUNGLASSES GG0053S 001 BLACK 54MM</p>
            <p>
              $337.50 <span className="color">Save 25%</span>{" "}
            </p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/1311784203_RLLZ_1_360x.jpg?v=1645585865"
              alt=""
            />
            <p>STUART WEITZMAN KEELAN LEATHER TALL BOOT</p>
            <p>
              $269.99 <span className="color">Save 61%</span>{" "}
            </p>
          </div>
          <div className="diva-1">
            <img
              src="https://cdn.shopify.com/s/files/1/0248/3473/6191/products/9f8823b8-195e-4999-9b82-440c7c81bc9d_1800x1800.jpg?v=1627405619"
              alt=""
            />
            <p>BURBERRY BLACK TB MOTIF POLO SHIRT</p>
            <p>
              $306.00 <span className="color">Save 40%</span>{" "}
            </p>
          </div>
        </div>

        <button className="btn1">VIEW ALL</button>
    </div>

    );
  };